import { BookingsHeader, BookingsPanel } from "@/components/organisms";
import { BookingFiltersProvider } from "@/components/organisms/Bookings/hooks/useBookingFilters";

export const Bookings = () => {
  return (
    <BookingFiltersProvider>
      {/* Deliberately uncapped, unlike its siblings. DEV-1367 capped this column at 2360px to stop the
          booking table stretching on ultrawide, but operators run this page on 3440px displays all day
          and reported the opposite problem: ~540px of white gutter either side of a table that was
          STILL scrolling horizontally inside it. Clients/Companies/Drivers and ClientHome keep their
          caps — they're forms and cards, which do get unreadable at that width; this one is a dense
          table where more width is the point.
          Note the table only grows to the sum of its column widths (DataTableV2's DefaultTable sets an
          explicit px width), so removing the cap recovers most of the gutter but not all of it. */}
      <div className="flex w-full flex-1 flex-col">
        <BookingsHeader />
        <BookingsPanel />
      </div>
    </BookingFiltersProvider>
  );
};
